import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import Breadcrumb from '../../components/Breadcrumb';
import Sidebar from '../../components/Blog/Sidebar';
import axios from 'axios';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';

const BlogDetailsMain = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [blogData, setBlogData] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const availablePostIds = [4, 5, 6, 7, 8];
  const daysTogglePostIds = [4, 5, 6, 7, 8];

  const openModal = () => setIsOpen(!isOpen);

  useEffect(() => {
    setLoading(true);
    setMessage('');
    axios
      .get(`https://ricgop.online/api/eventz.php?id=${id}`)
      .then((res) => {
        if (res.data && !res.data.error) {
          setBlogData(res.data);
          if (res.data.gallery && Array.isArray(res.data.gallery)) {
            setGalleryImages(res.data.gallery);
          }
        } else {
          setBlogData(null);
        }
        setLoading(false);
      })
      .catch(() => {
        setBlogData(null);
        setLoading(false);
      });
  }, [id]);

  const handleDayClick = (postId, dayNumber) => {
    if (availablePostIds.includes(postId)) {
      navigate(`/blog-details/${postId}`);
    } else {
      setMessage(`Day ${dayNumber} is in session. Please check back later.`);
      setTimeout(() => setMessage(''), 4000);
    }
  };

  const imageUrl = blogData ? `/assets/img/${blogData.image_url}` : '';
  const formattedDate = blogData
    ? new Date(blogData.published_date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : '';

  return (
    <main>
      <Breadcrumb title={blogData?.title || 'Event Details'} subTitle="Event" />

     {loading ? (
  <div className="modern-loader-wrapper">
    <div className="modern-spinner"></div>
    <p className="loading-text">Loading event details...</p>
  </div>
) : !blogData ? (
  <p className="text-center">Blog not found.</p>
) : (
  <>
          {daysTogglePostIds.includes(parseInt(id)) && (
            <div className="day-toggle-wrapper">
              <div className="day-toggle-content">
                <h5>Course Days</h5>
                <div className="day-buttons">
                  {[4, 5, 6, 7, 8].map((postId, index) => (
                    <button
                      key={postId}
                      onClick={() => handleDayClick(postId, index + 1)}
                      className={`day-btn ${parseInt(id) === postId ? 'active' : ''}`}
                    >
                      Day {index + 1}
                    </button>
                  ))}
                </div>
                {message && <div className="day-message">{message}</div>}
              </div>
            </div>
          )}

          <div className="postbox-area pt-120 pb-120 bg-light">
            <ModalVideo
              channel="youtube"
              isOpen={isOpen}
              videoId="PO_fBTkoznc"
              onClose={openModal}
            />
            <div className="container">
              <div className="row">
                <div className="col-xl-8 col-lg-8">
                  <div className="postbox-details-wrapper bg-white p-4 shadow-sm rounded-3">
                    <article className="postbox-item">
                      <div className="postbox-thumb radius mb-4">
                        <img
                          src={imageUrl}
                          alt={blogData.title || 'Event Image'}
                          className="img-fluid rounded"
                        />
                      </div>
                      <div className="postbox-meta mb-3 d-flex gap-3 text-muted small">
                        <span>
                          <i className="flaticon-user-1"></i> {blogData.author_name}
                        </span>
                        <span>
                          <i className="flaticon-clock"></i>
                          {`${blogData.published_month} ${blogData.published_date}, ${new Date().getFullYear()}`}
                        </span>
                        <span>
                          <i className="flaticon-view"></i> {blogData.views || 0} views
                        </span>
                      </div>
                      <div className="postbox-content-box">
                        <h2 className="fw-bold mb-4 text-dark">{blogData.title}</h2>
                        <div
                          className="postbox-dsc content-area styled-content"
                          dangerouslySetInnerHTML={{ __html: blogData.content }}
                        ></div>

                        {galleryImages.length > 0 && (
                          <div className="event-gallery mt-5">
                            <h4 className="mb-4 text-primary">Event Gallery</h4>
                            <div className="row g-3">
                              {galleryImages.map((img, index) => (
                                <div
                                  key={index}
                                  className="col-6 col-md-4 col-lg-3"
                                  onClick={() => {
                                    setPhotoIndex(index);
                                    setLightboxOpen(true);
                                  }}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <div className="gallery-image-wrapper position-relative rounded shadow-sm overflow-hidden">
                                    <img
                                      src={img.image_url}
                                      alt={`Gallery ${index + 1}`}
                                      className="img-fluid gallery-thumb"
                                    />
                                    <div className="overlay">
                                      <i className="fas fa-search-plus"></i>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </article>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {lightboxOpen && (
        <Lightbox
          mainSrc={galleryImages[photoIndex].image_url}
          nextSrc={galleryImages[(photoIndex + 1) % galleryImages.length].image_url}
          prevSrc={
            galleryImages[(photoIndex + galleryImages.length - 1) % galleryImages.length]
              .image_url
          }
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + galleryImages.length - 1) % galleryImages.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % galleryImages.length)
          }
        />
      )}

      {/* Inline Styling */}
      <style>{`
 .modern-loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 0;
}

.modern-spinner {
  display: inline-block;
  width: 64px;
  height: 64px;
}

.modern-spinner:after {
  content: " ";
  display: block;
  width: 46px;
  height: 46px;
  margin: 1px;
  border-radius: 50%;
  border: 5px solid #ff0057;
  border-color: #ff0057 transparent #ff0057 transparent;
  animation: dual-ring 1.2s linear infinite;
}

@keyframes dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin-top: 15px;
  font-size: 16px;
  color: #666;
  font-weight: 500;
  letter-spacing: 0.3px;
}

        /* Existing styles kept intact... */
        .day-toggle-wrapper {
          position: fixed;
          right: 0;
          top: 140px;
          background: linear-gradient(145deg, #ff3d68, #ff0057);
          padding: 20px;
          border-radius: 12px 0 0 12px;
          color: #fff;
          z-index: 999;
          box-shadow: 0 0 15px rgba(255, 0, 87, 0.4);
          animation: floatToggle 3s ease-in-out infinite;
        }

        .day-toggle-content h5 {
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 12px;
        }

        .day-buttons {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .day-btn {
          background: rgba(255, 255, 255, 0.15);
          border: none;
          color: #fff;
          padding: 10px 15px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s ease;
        }

        .day-btn:hover {
          background: #fff;
          color: #ff0057;
          transform: translateX(-5px);
        }

        .day-btn.active {
          background: #fff;
          color: #ff0057;
          font-weight: 800;
          transform: scale(1.05);
        }

        .day-message {
          margin-top: 10px;
          background: #fff;
          color: #ff0057;
          padding: 10px;
          border-radius: 8px;
          font-weight: bold;
          text-align: center;
        }

        @media (max-width: 768px) {
          .day-toggle-wrapper {
            top: auto;
            bottom: 0;
            right: 0;
            left: 0;
            width: 100%;
            border-radius: 12px 12px 0 0;
            padding: 15px;
            text-align: center;
            animation: none;
          }

          .day-buttons {
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
          }

          .day-btn {
            flex: 1 1 auto;
            min-width: 80px;
            margin: 5px;
          }
        }

        .gallery-image-wrapper {
          position: relative;
          overflow: hidden;
          border-radius: 12px;
          transition: transform 0.3s ease;
        }

        .gallery-thumb {
          transition: transform 0.3s ease;
          border-radius: 12px;
        }

        .gallery-image-wrapper:hover .gallery-thumb {
          transform: scale(1.05);
        }

        .gallery-image-wrapper .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.4);
          color: #fff;
          opacity: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24px;
          transition: opacity 0.3s ease;
        }

        .gallery-image-wrapper:hover .overlay {
          opacity: 1;
        }
      `}</style>
    </main>
  );
};

export default BlogDetailsMain;
